import { createStoreWithProducer } from '@xstate/store';
import { produce } from 'immer';

export interface InsightFeedbackEntry {
  feedbackId: string;
  feedbackType: 'POSITIVE' | 'NEGATIVE';
}

export type InsightFeedbackStoreContext = {
  entries: Record<string, InsightFeedbackEntry>;
};

const defaultContext: InsightFeedbackStoreContext = { entries: {} };

export const insightFeedbackStore = createStoreWithProducer(
  produce,
  defaultContext,
  {
    setFeedback: (
      context,
      event: { key: string; entry: InsightFeedbackEntry },
    ) => {
      context.entries[event.key] = event.entry;
    },
    clearEntries: (context) => {
      context.entries = {};
    },
  },
);
